import React from 'react'
import { graphql, gql, withApollo, compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'

import { translate } from 'react-i18next'

import { Form, LocationInput } from '../../UI'
import Loader from '../../UI/Loader'
import { NotificationManager } from 'react-notifications'

import { validateRequired } from '../../../libs/validation'
import { geoSuggestToLocation, locationToGeoSuggest } from '../../../libs/utils'
import USER_QUERY from './../../../graphql/UserByID.graphql'
import get from 'lodash/get'

class GuruLocationsForm extends React.Component {
 
  state = {
    saving: false,
    items: [
      {
        id: _.uniqueId(),
        location: null,
        geoLocation: null
      }
    ],
    error: '',
    routeIndex: 5
  }

  componentWillMount() {
    const locations = _.get(this, 'props.data.User.plannerProfile.locations')
    if (locations !=undefined && locations.length >0) {
      
      const items = locations.map(location => {
        return {
          id: _.uniqueId(),
          location,
          geoLocation: locationToGeoSuggest(location)
        }
      })
      this.setState({ items })
    }
  }

  componentWillReceiveProps(nextProps) {
    const locations = _.get(this, 'props.data.User.plannerProfile.locations')
    const newLocations = _.get(nextProps, 'data.User.plannerProfile.locations')
    if ((!locations || !locations.length) && newLocations && newLocations.length) {
      const items = newLocations.map(location => {
        return {
          id: _.uniqueId(),
          location,
          geoLocation: locationToGeoSuggest(location)
        }
      })
      this.setState({ items })
    }
  }

  handleSubmit = values => {
    this.props.validate(this.state.routeIndex, true)
    const { t } = this.props
    this.setState({
      saving: true,
      error: ''
    })
    const plannerProfileId = this.props.data.User.plannerProfile.id
    const locations = []
    for (let item in values) {
      if (values.hasOwnProperty(item) && values[item] && item.slice(0, 9) === 'location_') {
        if (locations.findIndex(location => location.googleId === values[item].placeId) !== -1) {
          this.setState({
            saving: false,
            error: t('unique_location_error')
          })
          return
        }
        locations.push(geoSuggestToLocation(values[item]))
      }
    }
    const googleIds = locations.map(location => location.googleId)

    locations.forEach(location => {
      location.plannerProfiles = [plannerProfileId]
    })
    const locationQuery = gql`
      query locationQuery($googleIds: [String!]) {
        allLocations(filter: { googleId_in: $googleIds }) {
          id
          googleId
        }
      }
    `
    const foundGoogleIds = []
    this.props.client
      .query({
        query: locationQuery,
        variables: {
          googleIds
        }
      })
      .then(result => {

        const locationIds =  result.data.allLocations[0].id
          foundGoogleIds.push(result.data.allLocations[0].googleId)
        // const locationIds =  result.data.allLocations.map(location => {
        //   foundGoogleIds.push(location.googleId)
        //   return location.id
          
        // })
        return this.props.updatePlannerProfile({
          variables: {
            id: plannerProfileId,
            locations: locationIds
          }
        })
      })
      .then(result => {
        const newLocations = locations.filter(location => {
          return foundGoogleIds.indexOf(location.googleId) === -1
        })
        const createPromises = newLocations.map(location => {
          return this.props.createLocation({ variables: location })
        })
        return Promise.all(createPromises)
      })
      .then(result => {
        this.props.data.refetch()
        NotificationManager.success('Locations updated', 'Success', 5000)
        this.setState(
          () => ({
            saving: false
          }),
          () => {
            this.props.history.push('/create-guru-profile/category')
          }
        )
      })
      .catch(err => {
        this.setState(() => ({
          saving: false
        }))

        NotificationManager.error('Error while updating locations', 'Error', 5000)
      })
  }

  handleAddClick = () => {
    this.setState({
      items: [
        ...this.state.items,
        {
          id: _.uniqueId(),
          location: null,
          geoLocation: null
        }
      ]
    })
  }

  handleRemoveClick = id => {
    const items = this.state.items.filter(item => item.id !== id)
    this.setState({ items })
  }

  render() {
    const { t } = this.props

    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }
    const { saving } = this.state
    return (
      <div className="steps-screen__form faded-container">
        <div className="steps-screen__form-title">{t('location_title')}</div>
        <div className="steps-screen__form-subtitle">{t('location_description_title')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="steps-screen__form-input-area">
            <div>
             
             
              {

                this.state.items.map(el => {
                 if(el.geoLocation!=null) {
                  
                
                   
                //  if(el.geoLocation.description!=""){
                      return (
                        <div key={el.id} className="removable-item-row">
                          <LocationInput
                            id={`location_${el.id}`}
                            placeholder={t('example_location')}
                            validationFuncs={[validateRequired]}
                            initialValue={el.geoLocation}
                            isGroup={true}
                          />
                          {
                            this.state.items.length > 1 && (
                            <div className="remove-item-link" onClick={() => this.handleRemoveClick(el.id)}>
                              <span className="icon-cancel" /> {t('main:remove')}
                            </div>
                          )
                          }
                        </div>
                      )
                   // }
                  }else{
                    return (
                      <div key={el.id} className="removable-item-row">
                        <LocationInput
                          id={`location_${el.id}`}
                          placeholder={t('example_location')}
                          validationFuncs={[validateRequired]}
                          initialValue={el.geoLocation}
                          isGroup={true}
                        />
                        {
                          this.state.items.length > 1 && (
                          <div className="remove-item-link" onClick={() => this.handleRemoveClick(el.id)}>
                            <span className="icon-cancel" /> {t('main:remove')}
                          </div>
                        )
                        }
                      </div>
                    )


                  }
              })}
              {this.state.error && <small className="text-danger">{this.state.error}</small>}
            </div>
            <div className="add-item-link" onClick={this.handleAddClick}>
              <span className="icon-plus" /> {t('add_location')}
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

const updatePlannerProfile = gql`
  mutation updatePlannerProfile($id: ID!, $locations: [ID!]) {
    updatePlannerProfile(id: $id, locationsIds: $locations) {
      id
      locations {
        id
      }
    }
  }
`

const createLocation = gql`
  mutation createLocation(
    $cityWithDistrict: String!
    $country: String!
    $city: String!
    $description: String!
    $lat: Float!
    $lng: Float!
    $googleId: String!
    $plannerProfiles: [ID!]
  ) {
    createLocation(
      cityWithDistrict: $cityWithDistrict
      country: $country
      city: $city
      description: $description
      lat: $lat
      lng: $lng
      googleId: $googleId
      plannerProfilesIds: $plannerProfiles
    ) {
      id
    }
  }
`

const updatePlannerProfileAndCreateLocations = gql`
  mutation updatePlannerProfileAndConnectToLocations($id: ID!, $locations: [PlannerProfilelocationsLocation!]) {
    updatePlannerProfile(id: $id, locations: $locations) {
      id
      locations {
        id
      }
    }
  }
`

const userQuery = gql`
  query userQuery {
    user {
      id
      plannerProfile {
        id
        locations {
          id
          cityWithDistrict
          country
          city
          description
          lat
          lng
          googleId
        }
      }
    }
  }
`

const TranslatedGuruLocationsForm = translate('guru')(GuruLocationsForm)

export default compose(
  graphql(updatePlannerProfile, { name: 'updatePlannerProfile' }),
  graphql(createLocation, { name: 'createLocation' }),
  graphql(updatePlannerProfileAndCreateLocations, { name: 'updatePlannerProfileAndCreateLocations' }),
  graphql(USER_QUERY, {
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  })  
)(withRouter(withApollo(TranslatedGuruLocationsForm)))



// WEBPACK FOOTER //
// src/components/Guru/CreateGuruProfile/GuruLocationsForm.jsx